import { GenericServiceResponse } from './generic-service-response';
import { ResponseCachedDecorator } from './decorators/response-cached.decorator';
import { CreateResponseInterface, IdentityInterface, ModelInterface } from '@nts/std/interfaces';

@ResponseCachedDecorator()
export class CreateResponse<
    TModel extends ModelInterface<TIdentity>,
    TIdentity extends IdentityInterface>
    extends GenericServiceResponse<TModel> implements CreateResponseInterface<TModel, TIdentity> {

}
